import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
let currentDate = new moment()

export const selectAllVehicles = ({ VehicleList_reducer }) => {
    return VehicleList_reducer.allVehicles;
};
export const getRequesting = ({ VehicleList_reducer }) => {
    return VehicleList_reducer.requesting;
};
export const selectCategories = ({ VehicleList_reducer }) => {
    return VehicleList_reducer.category;
};
export const getTemplates = ({ VehicleList_reducer }) => {
    return VehicleList_reducer.templates;
};
export const selectVehicleType = ({ VehicleList_reducer }) => {
    return VehicleList_reducer.categoryType;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};

export const selectUser = ({ UserProfile_reducer }) => {
    return UserProfile_reducer.user;
};

export const getUserProfile = createSelector([selectUser], profiles => {
    if (
        profiles === false ||
        typeof profiles === "undefined" ||
        profiles === null
    ) {
        return [];
    }
    let name = profiles.profile.first_name + " " + profiles.profile.last_name
    return name
});

export const selectTemplates = createSelector([getTemplates], templates => {
    let titleArr = []
    if (
        templates === false ||
        typeof templates === "undefined" ||
        templates === null
    ) {
        return [];
    }

    Object.values(templates).map(e => {
        if(e.profile.deleted === false){
            let reference = e.profile.title.replace(/ /g,"_");
            let id = `custom_${reference}`
            titleArr.push(id)
            return null
        }
        return null;
    });
    return titleArr;
});


export const selectDepartments = createSelector(
    [selectProfile],
    ({ departments = false }) => {
        if (departments) return departments;
        else return null;
    }
);

export const selectAllVehicleTypes = createSelector(
    [selectCategories],
    (allVehicle) => {
        if (
            allVehicle === false ||
            typeof allVehicle === "undefined" ||
            allVehicle === null
        ) {
            return [];
        }
        let vehicleTypes = _.compact(Object.values(allVehicle));
        return vehicleTypes;
    }
);

export const selectCategoryTitles = createSelector([selectCategories], categories => {
    let titleArr = []
    if (
        categories === false ||
        typeof categories === "undefined" ||
        categories === null
    ) {
        return [];
    }

    Object.values(categories).map(e => {
        titleArr.push(e)
        return null;
    });
    return titleArr;
});


export const selectAreas = createSelector(
    [selectProfile],
    ({ areas = false }) => {
        if (areas) return areas;
        else return null;
    }
);

export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["machine_manager"];
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config ? config.read : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.create : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions, selectProfile],
    (config = false) => {
        return config ? config.delete : true;
    }
);
export const selectVehicles = createSelector(
    [selectAllVehicles, selectProfile, selectVehicleType],
    (vehicles, { departments = false, areas = false }, categoryType = false) => {
        if (vehicles) {
            let vehicleInfo = _.compact(
                Object.keys(vehicles).map(vehicle_uid => {
                    let created_by =
                        _.get(vehicles[vehicle_uid], "profile.created_by") ||
                        "";
                    let machine_comments =
                        _.get(
                            vehicles[vehicle_uid],
                            "profile.machine_comments"
                        ) || "";
                    let machine_desc =
                        _.get(vehicles[vehicle_uid], "profile.machine_desc") ||
                        "";
                    let machine_nct_expiry =
                        _.get(
                            vehicles[vehicle_uid],
                            "profile.machine_nct_expiry"
                        ) || "";
                    let machine_reg =
                        _.get(vehicles[vehicle_uid], "profile.machine_reg") ||
                        "";
                    let machine_status =
                        _.get(
                            vehicles[vehicle_uid],
                            "profile.machine_status"
                        ) || "";
                    let machine_tax_expiry =
                        _.get(
                            vehicles[vehicle_uid],
                            "profile.machine_tax_expiry"
                        ) || "";
                    let photo_url =
                        _.get(vehicles[vehicle_uid], "profile.photo_url") || "";
                    let areas =
                        _.get(vehicles[vehicle_uid], "profile.areas") || null;
                    let qr_code_url =
                        _.get(vehicles[vehicle_uid], "profile.qr_code_url") ||
                        "";
                    let attached_files =
                        _.get(
                            vehicles[vehicle_uid],
                            "profile.attached_files"
                        ) || null;
                    let attached_photos =
                        _.get(
                            vehicles[vehicle_uid],
                            "profile.attached_photos"
                        ) || null;
                    let departments =
                        _.get(vehicles[vehicle_uid], "profile.departments") ||
                        null;
                    let service_period =
                        _.get(
                            vehicles[vehicle_uid],
                            "profile.service_period"
                        ) || "";
                    let history = _.get(vehicles[vehicle_uid], "history") || "";
                    let machine_category = _.get(vehicles[vehicle_uid], "profile.machine_category") || "";
                    let machine_nickname = _.get(vehicles[vehicle_uid], "profile.machine_nickname") || "";
                    let last_service_date = _.get(vehicles[vehicle_uid], "profile.last_service_date") || "";
                    let machine_insurance_expiry = _.get(vehicles[vehicle_uid], "profile.machine_insurance_expiry") || "";
                    let thorough_inspection_service_period = _.get(vehicles[vehicle_uid], "profile.thorough_inspection_service_period") || "";
                    let inspection_template = _.get(vehicles[vehicle_uid], "profile.inspection_template") || "";
                    let inspection_records = _.get(vehicles[vehicle_uid], "profile.inspection_records") || null;
                    let service_data = _.get(vehicles[vehicle_uid], "profile.service_data") || null;
                    let receipts = _.get(vehicles[vehicle_uid], "receipts") || null;
                    let lastVehcileInspection = ""
                    let lastReceiptStatus = ""
                    if (receipts !== null) {
                        let recent = "";
                        let timeref = ""
                        let statusRef = ""
                        Object.values(receipts).map((e) => {
                            let refObj = e;
                            let refdate = moment(e.timestamp, "DD-MM-YYYY HH:mm:ss")
                            refObj['utc'] = parseInt((new Date(refdate).getTime() / 1000).toFixed(0))
                            if (e.utc > recent) {
                                timeref = ""
                                recent = e.utc;
                                timeref = e.timestamp
                                statusRef = e.inspection_status
                                lastVehcileInspection = timeref
                                lastReceiptStatus = statusRef
                            }
                            return null;
                        })
                    }

                    let lastThoroughInspectionDate = "N/A"
                    if(inspection_records !== null)
                    {
                        let throughInspectionRecord = inspection_records && inspection_records.map((e) => { return e })
                        let referenceVariable  = throughInspectionRecord[throughInspectionRecord.length - 1]
                        lastThoroughInspectionDate = referenceVariable.timestamp      
                    }              
                    let liveStatus = "N/A"
                    if (lastReceiptStatus === "Do Not Use") {
                        liveStatus = "Do Not Use"
                    }

                    if (lastReceiptStatus === "Temporary Fix") {
                        liveStatus = "Needing Repair"
                    }
                    
                    if(lastThoroughInspectionDate !== "N/A" && thorough_inspection_service_period !== "" && liveStatus === "N/A")
                    {
                        let weeksToDays = thorough_inspection_service_period * 7;
                        let nextThoroughInspectionDate = moment(lastThoroughInspectionDate, "DD-MM-YYYY").add(weeksToDays, "d");
                        let bufferDate = moment(nextThoroughInspectionDate, "DD-MM-YYYY").subtract(7, "d");
                        if(currentDate.isAfter(bufferDate) && currentDate.isBefore(nextThoroughInspectionDate))
                        {
                            liveStatus = "Needing Thorough Inspection"
                        }
                    }

                    if(machine_nct_expiry !== "" && machine_tax_expiry !=="" && machine_insurance_expiry !== "" && liveStatus === "N/A")
                    {
                        let machine_nct_expiry_compare = moment(machine_nct_expiry, "DD-MM-YYYY")
                        let machine_tax_expiry_compare = moment(machine_tax_expiry, "DD-MM-YYYY")
                        let machine_insurance_expiry_compare = moment(machine_insurance_expiry, "DD-MM-YYYY")
                        if(currentDate.isAfter(machine_nct_expiry_compare) || currentDate.isAfter(machine_tax_expiry_compare) || currentDate.isAfter(machine_insurance_expiry_compare))
                        {
                            liveStatus = "Certs out of Date"
                        }
                    }

                    if(machine_nct_expiry !== "" && liveStatus === "N/A")
                    {
                        let machine_nct_expiry_compare = moment(machine_nct_expiry, "DD-MM-YYYY")
                        if(currentDate.isAfter(machine_nct_expiry_compare))
                        {
                            liveStatus = "Certs out of Date"
                        }   
                    }
                    if( machine_tax_expiry !== "" && liveStatus === "N/A")
                    {
                        let machine_tax_expiry_compare = moment(machine_tax_expiry, "DD-MM-YYYY")
                        if(currentDate.isAfter(machine_tax_expiry_compare))
                        {
                            liveStatus = "Certs out of Date"
                        }   
                    }
                    if(machine_insurance_expiry !== "" && liveStatus === "N/A")
                    {
                        let machine_insurance_expiry_compare = moment(machine_insurance_expiry, "DD-MM-YYYY")
                        if(currentDate.isAfter(machine_insurance_expiry_compare))
                        {
                            liveStatus = "Certs out of Date"
                        }   
                    }

                    if(last_service_date !== "" && service_period !== "" && liveStatus === "N/A")
                    {
                        let weeksToDays = service_period * 7;
                        let nextServiceDate = moment(last_service_date, "DD-MM-YYYY").add(weeksToDays, "d");
                        let bufferDate = moment(nextServiceDate, "DD-MM-YYYY").subtract(7, "d");
                        if(currentDate.isAfter(bufferDate) && currentDate.isBefore(nextServiceDate))
                        {
                            liveStatus = "Needing Service"
                        }
                    }
                    if(thorough_inspection_service_period !== "" && lastThoroughInspectionDate !== "" && liveStatus === "N/A")
                    {
                        let weeksToDays = thorough_inspection_service_period * 7;
                        let nextInspectionDate = moment(lastThoroughInspectionDate, "DD-MM-YYYY").add(weeksToDays, "d");
                        let buffer = thorough_inspection_service_period / 4;
                        if (buffer === 0) {
                            buffer = 1;
                        }
                        let buffertoDays = buffer * 7;
                        let refDate = moment(nextInspectionDate, "DD-MM-YYYY").subtract(buffertoDays, "d");
                        if (currentDate.isAfter(refDate) && currentDate.isBefore(nextInspectionDate)) {
                            liveStatus = "Thorough Inspection Due"
                        }
                    }
                    if(machine_nct_expiry !== "" && machine_tax_expiry !=="" && machine_insurance_expiry !== "" && liveStatus === "N/A")
                    {
                        let machine_nct_expiry_compare = moment(machine_nct_expiry, "DD-MM-YYYY").subtract(21, "d");
                        let machine_tax_expiry_compare = moment(machine_tax_expiry, "DD-MM-YYYY").subtract(21, "d");
                        let machine_insurance_expiry_compare = moment(machine_insurance_expiry, "DD-MM-YYYY").subtract(21, "d");
                        if(currentDate.isAfter(machine_nct_expiry_compare) || currentDate.isAfter(machine_tax_expiry_compare) || currentDate.isAfter(machine_insurance_expiry_compare) )
                        {
                            liveStatus = "Certs Due"
                        }
                    }

                    if(machine_nct_expiry !== "" && liveStatus === "N/A")
                    {
                        let machine_nct_expiry_compare = moment(machine_nct_expiry, "DD-MM-YYYY").subtract(21, "d");
                        if(currentDate.isAfter(machine_nct_expiry_compare))
                        {
                            liveStatus = "Certs Due"
                        }   
                    }
                    if( machine_tax_expiry !== "" && liveStatus === "N/A")
                    {
                        let machine_tax_expiry_compare = moment(machine_tax_expiry, "DD-MM-YYYY").subtract(21, "d");
                        if(currentDate.isAfter(machine_tax_expiry_compare))
                        {
                            liveStatus = "Certs Due"
                        }   
                    }
                    if(machine_insurance_expiry !== "" && liveStatus === "N/A")
                    {
                        let machine_insurance_expiry_compare = moment(machine_insurance_expiry, "DD-MM-YYYY").subtract(21, "d");
                        if(currentDate.isAfter(machine_insurance_expiry_compare))
                        {
                            liveStatus = "Certs Due"
                        }   
                    }
                    if(service_period !== "" && last_service_date !== "" && liveStatus === "N/A")
                    {
                        let weeksToDays = service_period * 7;
                        let nextServiceDate = moment(last_service_date, "DD-MM-YYYY").add(weeksToDays, "d");
                        let buffer = service_period / 4;
                        if (buffer === 0) {
                            buffer = 1;
                        }
                        let buffertoDays = buffer * 7;
                        let refDate = moment(nextServiceDate, "DD-MM-YYYY").subtract(buffertoDays, "d");
                        if (currentDate.isAfter(refDate) && currentDate.isBefore(nextServiceDate)) {
                            liveStatus = "Service Due"
                        }
                    }
                    if(liveStatus === "N/A")
                    {
                        liveStatus = "Operational"
                    }
                    if(inspection_records === null)
                    {
                        inspection_records = []
                    } 
                    if(service_data === null)
                    {
                        service_data = []
                    } 
                    return {
                        uid: vehicle_uid,
                        profile: {
                            created_by,
                            attached_files,
                            attached_photos,
                            machine_comments,
                            machine_desc,
                            machine_nct_expiry,
                            machine_reg,
                            machine_status,
                            machine_tax_expiry,
                            photo_url,
                            areas,
                            departments,
                            qr_code_url,
                            service_period,
                            machine_category,
                            machine_nickname,
                            last_service_date,
                            machine_insurance_expiry,
                            thorough_inspection_service_period,
                            inspection_template,
                            inspection_records,
                            service_data,
                            lastVehcileInspection,
                            lastThoroughInspectionDate,
                            liveStatus
                        },
                        history,
                        receipts
                    };
                })
            );
            if (departments) {
                vehicleInfo = vehicleInfo.filter(e => {
                    if (e.profile.departments) {
                        let flag = false;
                        e.profile.departments.map(qrd => {
                            departments.map(f => {
                                if (f === qrd) {
                                    flag = true;
                                }
                                return null;
                            });
                            return null;
                        });
                        return flag;
                    } else {
                        return true;
                    }
                });
            }
            if (areas) {
                vehicleInfo = vehicleInfo.filter(e => {
                    if (e.profile.areas) {
                        let flag = false;
                        e.profile.areas.map(qrd => {
                            areas.map(f => {
                                if (f === qrd) {
                                    flag = true;
                                }
                                return null;
                            });
                            return null;
                        });
                        return flag;
                    } else {
                        return true;
                    }
                });
            }
            if (categoryType !== "all_categories") {
                vehicleInfo = vehicleInfo.filter((e) => {

                    return e.profile.machine_category === categoryType;
                });
            }
            return _.orderBy(vehicleInfo, "profile.machine_desc");
        } else {
            return false;
        }
    }
);

